var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap-evidencia" }, [
    _c("div", { staticClass: "modalEnvio", attrs: { id: "myModal2" } }, [
      _c(
        "div",
        {
          staticClass: "modalEnvio-content",
          staticStyle: { width: "40%!important" }
        },
        [
          _c(
            "div",
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "buttonClose buttonCloseEvidencia",
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.closeEnvio()
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("close")
                      ]),
                      _vm._v("  \n            "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Cerrar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c("span", [_vm._v("Nombre: ")]),
                _c("span", [_vm._v(_vm._s(_vm.nombre))])
              ]),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.edittelefono,
                        expression: "edittelefono"
                      }
                    ],
                    attrs: {
                      label: "Teléfono",
                      "single-line": "",
                      type: "number"
                    },
                    model: {
                      value: _vm.telefono,
                      callback: function($$v) {
                        _vm.telefono = $$v
                      },
                      expression: "telefono"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      show: "editmail",
                      label: "Email",
                      type: "email",
                      "single-line": ""
                    },
                    on: { blur: _vm.validateEmail },
                    model: {
                      value: _vm.correo,
                      callback: function($$v) {
                        _vm.correo = $$v
                      },
                      expression: "correo"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: { flat: "", icon: "", small: "" },
                        on: { click: _vm.handleActualizarDatosClick }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("send")
                        ]),
                        _vm._v("  \n              Actualizar\n            ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c(
        "h3",
        {
          staticClass: "importExportBtnIcon",
          staticStyle: {
            "font-size": "20px!important",
            "margin-bottom": "20px!important"
          }
        },
        [
          _vm._v(
            "\n            Por favor completa los datos del contacto principal de tu empresa\n          "
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }